<div id="printContent">
  <wf-page-tour [steps]="tourSteps"></wf-page-tour>
  <div class="header-controls">
    <h3>
      <fa-icon [icon]="reportsIcon"/>
      Reports
    </h3>
  </div>
  <div class="print-hide" *ngIf="showSchoolFilter">
    <wf-school-teacher-filter
      [error]="schoolFilterError"
      [districts]="districts"
      [schools]="schools"
      [teachers]="teachers"
      (filterChangeEvent)="filterSchoolTeacher($event)"
    ></wf-school-teacher-filter>
  </div>
  <div  [ngClass]="{ 'disabled-report' : schoolFilterError }"></div>
  <div class="flex justify-content-end gap-2 report-header-buttons margin-bottom-5">
    <refresh-button (click)="refreshDashboardData()"></refresh-button>
  </div>
  <div class="report-section-header" style="justify-content: space-between;">
    <h5 class="results-report-header">
      <fa-icon [icon]="dashboardIcon"></fa-icon>
      Teacher Dashboard
    </h5>
    <div class="button-group margin-right-10">
      <div *ngIf="showCoTeacherFilter" class="form-check">
        <input id="coteacher-checkbox" class="form-check-input" type="checkbox" (change)="toggleSharedStudents()">
        <label class="form-check-label" for="coteacher-checkbox">Hide Shared Students</label>
      </div>
    </div>
  </div>
  <div class="dashboard-container">
    <div class="dashboard-cards-grid">

      <!-- Daily Notifications -->
      <div class="dashboard-card daily-notifications" id="daily-notifications">
        <div class="dashboard-card-header notifications">
          <fa-icon [icon]="notificationsIcon"></fa-icon>
          <span>Daily Notifications</span>
        </div>
        <div class="dashboard-card-body">
          <div class="notification-totals">
            <div class="notification-tile">
              <div class="notification-number">{{ celebrationsCount }}</div>
              <div class="notification-label">Student Celebrations</div>
            </div>
            <div class="notification-tile">
              <div class="notification-number">{{ needAttentionCount }}</div>
              <div class="notification-label">Students Need Attention</div>
            </div>
          </div>
          <!-- TODO(dashboard-notifications): /notifications/recent is a real route but
               the page is still a stub (NotificationsService returns no data) and is
               gated to teacher roles only, while this dashboard is visible to more
               roles. -->
          @if (canViewNotifications) {
            <button class="btn dashboard-button" [routerLink]="'/notifications/recent'">Go to Notifications</button>
          }
        </div>
      </div>

      <!-- Weekly Reminders -->
      <div class="dashboard-card weekly-reminders" id="weekly-reminders">
        <div class="dashboard-card-header reminders">
          <fa-icon [icon]="remindersIcon"></fa-icon>
          <span>Weekly Reminders</span>
        </div>
        <div class="dashboard-card-body">
          <ul class="reminders-list">
            <li *ngFor="let reminder of weeklyReminders">
              <span class="reminder-check"><fa-icon [icon]="checkIcon"></fa-icon></span>
              <span class="reminder-text">
                <strong>{{ reminder.cardTitle }}</strong>
                <span class="reminder-detail">{{ reminder.cardText }}</span>
              </span>
            </li>
          </ul>
          <button class="btn dashboard-button" (click)="showReminderDetails()">View Details</button>
        </div>
      </div>

      <!-- Minutes Usage -->
      <div class="dashboard-card minutes-usage" id="minutes-usage">
        <div class="dashboard-card-header usage">
          <fa-icon [icon]="usageIcon"></fa-icon>
          <span>Minutes Usage</span>
          <div class="usage-week-toggle">
            <div class="form-check form-check-inline">
              <input id="usage-previous" class="form-check-input" type="radio" name="usageWeek" value="previous" [(ngModel)]="selectedUsageWeek" (change)="updateUsageBuckets()">
              <label class="form-check-label" for="usage-previous">Previous Week</label>
            </div>
            <div class="form-check form-check-inline">
              <input id="usage-current" class="form-check-input" type="radio" name="usageWeek" value="current" [(ngModel)]="selectedUsageWeek" (change)="updateUsageBuckets()">
              <label class="form-check-label" for="usage-current">Current Week</label>
            </div>
          </div>
        </div>
        <div class="dashboard-card-body usage-body">
          <div class="usage-ranges">
            <div class="usage-range over-60">
              <div class="usage-percent">{{ usagePercent(usageBuckets.over60.length) | number:'1.0-0' }}%</div>
              <div class="usage-detail">
                <div class="usage-range-label">60+ Minutes</div>
                <div class="usage-count">{{ usageBuckets.over60.length }} Students</div>
              </div>
              <button class="btn dashboard-button" (click)="showUsageList('60+ Minutes', usageBuckets.over60)">View List</button>
            </div>
            <div class="usage-range mid">
              <div class="usage-percent">{{ usagePercent(usageBuckets.mid.length) | number:'1.0-0' }}%</div>
              <div class="usage-detail">
                <div class="usage-range-label">40 - 60 Minutes</div>
                <div class="usage-count">{{ usageBuckets.mid.length }} Students</div>
              </div>
              <button class="btn dashboard-button" (click)="showUsageList('40 - 60 Minutes', usageBuckets.mid)">View List</button>
            </div>
            <div class="usage-range under-40">
              <div class="usage-percent">{{ usagePercent(usageBuckets.under40.length) | number:'1.0-0' }}%</div>
              <div class="usage-detail">
                <div class="usage-range-label">0 - 40 Minutes</div>
                <div class="usage-count">{{ usageBuckets.under40.length }} Students</div>
              </div>
              <button class="btn dashboard-button" (click)="showUsageList('0 - 40 Minutes', usageBuckets.under40)">View List</button>
            </div>
          </div>
          <div class="usage-pie">
            <div class="usage-pie-chart">
              <canvas baseChart
                      [data]="pieChartData"
                      [type]="pieChartType"
                      [options]="pieChartOptions"></canvas>
            </div>
            <div class="usage-pie-total">{{ totalUsageStudents }} students</div>
          </div>
        </div>
      </div>

      <!-- Unit Placement -->
      <div class="dashboard-card unit-placement" id="unit-placement">
        <div class="dashboard-card-header unit">
          <span>Unit Placement</span>
        </div>
        <div class="dashboard-card-body">
          <div class="dashboard-bar-graph">
            <canvas baseChart
                    id="unit-placement-chart"
                    [data]="chartData"
                    [type]="chartType"
                    [options]="chartOptions"
                    [plugins]="chartPlugins"></canvas>
          </div>
        </div>
      </div>

    </div>

    <ng-template #remindersmodal let-modal>
      <div class="modal-header reminders-modal-header">
        <h5 class="modal-title">
          <fa-icon [icon]="remindersIcon"></fa-icon>
          Weekly Reminders
        </h5>
        <button type="button" class="btn reminders-print-button print-hide" (click)="printReminders()">Print</button>
      </div>
      <div class="modal-body reminders-modal-body">
        <div class="reminder-details">
          <div class="reminder-detail-headers">
            <div class="reminder-col-todo-head">To Do</div>
            <div class="reminder-col-where-head">Where to look&hellip;</div>
          </div>
          <div class="reminder-detail-row" *ngFor="let reminder of weeklyReminders">
            <div class="reminder-todo">
              <span class="reminder-check"><fa-icon [icon]="checkIcon"></fa-icon></span>
              <div class="reminder-todo-body">
                <div class="reminder-todo-heading">{{ reminder.detailTitle }}</div>
                <hr class="reminder-rule">
                <p class="reminder-todo-text">{{ reminder.detailBody }}</p>
              </div>
            </div>
            <div class="reminder-where">
              <div class="reminder-where-label">{{ reminder.whereToLookLabel }}</div>
              <a class="reminder-where-link" [routerLink]="reminder.linkRoute" (click)="modal.close()">{{ reminder.linkText }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer reminders-modal-footer">
        <button type="button" class="btn dashboard-button" (click)="modal.dismiss()">Done</button>
      </div>
    </ng-template>

    <ng-template #usagelistmodal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ selectedUsageRangeLabel }}</h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <table class="table table-sm ac-dashboard weekly-usage-goal">
          <thead>
            <tr>
              <th scope="col">Student</th>
              <th scope="col">Weekly Usage (min)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let session of selectedUsageRangeStudents">
              <td>{{ session.student.firstName }} {{ session.student.lastName }}</td>
              <td>{{ getDisplaySessionTime(session.sessionTime) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn action-button" (click)="modal.dismiss()">Close</button>
      </div>
    </ng-template>
  </div>
</div>
